export type Cell = 0 | 1 | 2; // empty, X (player 1), O (player 2)

export interface TicTacToeGame {
  board: Cell[][];
  size: number;
  connect: number;
  turn: 1 | 2;
  winner: 0 | 1 | 2;
  winningCells: Array<{ r: number; c: number }>;
  isDraw: boolean;
}

export interface LevelConfig {
  size: number;
  connect: number;
  label: string;
}

export const LEVEL_CONFIGS: Record<"easy" | "medium" | "hard", LevelConfig> = {
  easy: { size: 3, connect: 3, label: "3×3" },
  medium: { size: 4, connect: 3, label: "4×4" },
  hard: { size: 5, connect: 4, label: "5×5" },
};
